import clsx from "clsx";
import { FC } from "react";
import styled from "styled-components";

import { useDynamicFormsTranslate } from "@ryde/redux";
import { FontVariantEnum, ICustomField, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

const variantBlockClass: Record<FontVariantEnum, string> = {
  [FontVariantEnum.Default]: "section-title--default",
  [FontVariantEnum.Small]: "section-title--small",
  [FontVariantEnum.ExtraSmall]: "section-title--extra-small",
};

const SectionTitleStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "section-title-template",
})<{ $labelColor?: string | null }>`
  display: flex;
  align-items: center;
  padding: 2px;
  width: 100%;

  .section-title__label {
    font-weight: 500;
  }

  &.section-title--default .section-title__label {
    font-size: 1.4em;
    color: ${props => props.$labelColor || greyMui._900};
  }

  &.section-title--small .section-title__label {
    font-size: 1.4em;
    color: ${props => props.$labelColor || greyMui._800};
  }

  &.section-title--extra-small .section-title__label {
    font-size: 0.95em;
    color: ${props => props.$labelColor || greyMui._700};
  }
`;

export const SectionTitleTemplate: FC<ICustomField> = ({
  name,
  formLabel,
  formLabelColor,
  formIcon,
  formAttributes,
  labelTranslated,
}) => {
  const { formLabelTranslated } = useDynamicFormsTranslate({
    name,
    fallbackText: formLabel,
    translatedText: labelTranslated,
  });
  const fontVariant = formAttributes?.fontVariant ?? FontVariantEnum.Default;
  return (
    <SectionTitleStyled
      $labelColor={formLabelColor}
      className={clsx("section-title", variantBlockClass[fontVariant])}
      data-e2e-template="section-title-template"
      data-e2e-field-name={name}
    >
      {formIcon}
      <div className="section-title__label">{formLabelTranslated}</div>
    </SectionTitleStyled>
  );
};
